var modules_e185b7e9 = {"base-line":"_1avukqk","effect":"_15i4wh7","inverted":"_uc43o7","container":"_108r3tg","paragraph":"_1cbx8o9 _1avukqk","avatar":"_1hdathy _1avukqk","button":"_rqpett _1avukqk","block":"_1vzlfpc"};
import "../../../assets/Cu1cROcx.css";

export { modules_e185b7e9 as default };
//# sourceMappingURL=Skeleton.module.less.js.map
